import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LIB_CONFIG } from '../lib-config';
import { HttpClientOptions } from '../models/http-client-options.model';
import { LibConfig } from '../models/lib-config.model';
import { HandshakeService } from './handshake.service';
import { Observable, of } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { environment } from '../../../../../apps/content/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private baseUrl: string;
  public sessionDataCache = null;
  constructor(
    private http: HttpClient,
    private handshakeService: HandshakeService,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    this.baseUrl = this.config?.apigeeApi?.baseUrl;
  }

  getSessionData(httpOptions?: HttpClientOptions, useCache: boolean = true): Observable<any> {
    if (environment.envName !== 'prod') {
      return of(null);
    } else {
      if (this.sessionDataCache != null && useCache) {
        return of(this.sessionDataCache);
      } else {
        return this.handshakeService.getAuthorizationHeaders().pipe(
          mergeMap((authorizationHeaders: any) => {
            const { sessionData } = this.config.compaxAngularApi;
            return this.http.get(`${this.baseUrl}${sessionData}`, {
              ...authorizationHeaders,
              ...httpOptions,
            });
          }),
          tap((data) => {
            this.sessionDataCache = data;
          })
        );
      }
    }
  }

  addDataToPublicSession(body: any, httpOptions?: HttpClientOptions): Observable<any> {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const { sessionData } = this.config.compaxAngularApi;

        return this.http.put(`${this.baseUrl}${sessionData}`, body, {
          ...authorizationHeaders,
          ...httpOptions,
        });
      })
    );
  }

  macIdData(id) {
    return this.handshakeService.getAuthorizationHeaders().pipe(
      mergeMap((authorizationHeaders: any) => {
        const { macId } = this.config.compaxAngularApi;
        return this.http.post(`${this.baseUrl}${macId}`, id, authorizationHeaders);
      })
    );
  }
}
